import React from 'react';
import { C, LAYOUT } from '../../shared/design-tokens.js';
import { CONTROL_INPUT, MUTED_LABEL } from './scheduler-ui.js';
import type { TerminalOption } from './use-scheduler-read-model.js';

interface SchedulerContextRailProps {
  weekStart: string;
  selectedTerminalId: string;
  terminalOptions: TerminalOption[];
  onWeekStartChange: (value: string) => void;
  onTerminalChange: (value: string) => void;
}

export default function SchedulerContextRail({ weekStart, selectedTerminalId, terminalOptions, onWeekStartChange, onTerminalChange }: SchedulerContextRailProps) {
  return (
    <div style={LAYOUT.subPanel}>
      <div style={{ fontSize: 12, textTransform: 'uppercase', letterSpacing: '0.08em', color: C.gold, marginBottom: 12 }}>
        Scheduler context rail
      </div>
      <div style={{ display: 'grid', gap: 12, gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))' }}>
        <div>
          <label style={MUTED_LABEL}>Week anchor</label>
          <input type="date" value={weekStart} onChange={(event) => onWeekStartChange(event.target.value)} style={CONTROL_INPUT} />
        </div>
        <div>
          <label style={MUTED_LABEL}>Terminal scope</label>
          <select value={selectedTerminalId} onChange={(event) => onTerminalChange(event.target.value)} style={CONTROL_INPUT}>
            {terminalOptions.map((terminal: TerminalOption) => (
              <option key={terminal.id} value={terminal.id}>{terminal.name}</option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
}
